import { createContext } from "react";
import { I_ExecutablePermissions } from "../../Models/interfaces";

export const ExecutingPermissionsContext =
  createContext<I_ExecutablePermissions>({
    canSeeTenantTextBox: [],
  });
